import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import classNames from "classnames";
import styles from "../styles/pre-game-stats-widget.module.scss";

const PreGameStatsWidgetAsyncComponent = AsyncComponent(async () => import('./pre-game-stats-widget' /* webpackChunkName: "pre-game-stats-widget" */ ));

export const PreGameStatsWidgetAsync = (props) => {
  return <React.Suspense fallback={<div className={classNames(styles.placeholder)}/>}>
    <PreGameStatsWidgetAsyncComponent {...props}/>
  </React.Suspense>
};
